import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useApi } from '@/lib/api-context';

import { flowHistoryResponseSchema, type FlowHistoryItem } from './types';

interface Options {
  companyId: string | null;
  enabled: boolean;
}

/** Historial de transiciones de un flujo (alimenta el stepper). Solo aplica con flujo
 *  activo; sin flowInstanceId el stepper refleja el estado en reposo. */
export function useFlowHistory(
  flowInstanceId: string | null,
  { companyId, enabled }: Options,
): UseQueryResult<FlowHistoryItem[]> {
  const api = useApi();
  return useQuery({
    queryKey: ['flow-history', companyId, flowInstanceId],
    queryFn: async () => {
      const raw = await api.get<unknown>(
        `/api/v1/quality/documents/flows/${flowInstanceId}/history`,
      );
      return flowHistoryResponseSchema.parse(raw).data;
    },
    enabled: enabled && flowInstanceId !== null,
  });
}
